"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "podenzano": {
    "cbd982bc": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "skipSearch": false
    }],
    "due-case": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "podenzano"
    }],
    "d8239090": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "skipSearch": false
    }],
    "gariga": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f27a3d0b": [{
      "hkey": "914d06b5",
      "slug": "san-polo-crocetta",
      "name": "San Polo-Crocetta",
      "primary": true,
      "skipSearch": false
    }],
    "san-polo": [{
      "hkey": "914d06b5",
      "slug": "san-polo-crocetta",
      "name": "San Polo-Crocetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b9d8676": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "skipSearch": false
    }],
    "turro": [{
      "hkey": "8d6c93a3",
      "slug": "gariga-due-case-turro",
      "name": "Gariga-Due Case-Turro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "podenzano"
    }]
  }
};
exports["default"] = _default;